import React, { useEffect, useRef, lazy } from 'react';
interface Logo {
  url: string;
  alt: string;
}
interface LogoSliderProps {
  logos: Logo[];
}
export function LogoSlider({
  logos
}: LogoSliderProps) {
  const sliderRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    let animationId: number;
    let position = 0;
    const speed = 0.5; // pixels per frame
    const animate = () => {
      position -= speed;
      // Reset position when first set of logos has scrolled completely
      if (Math.abs(position) >= slider.scrollWidth / 2) {
        position = 0;
      }
      slider.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, []);
  // Duplicate logos for seamless loop
  const duplicatedLogos = [...logos, ...logos];
  return <div className="overflow-hidden py-12 bg-gray-50" data-id="element-129">
      <div className="container mx-auto px-6 lg:px-8" data-id="element-130">
        <h3 className="text-2xl font-bold text-gray-900 text-center mb-8" data-id="element-131">
          Trusted By
        </h3>
        <div className="relative" data-id="element-132">
          <div ref={sliderRef} className="flex items-center gap-16" style={{
          width: 'fit-content'
        }} data-id="element-133">
            {duplicatedLogos.map((logo, index) => <div key={index} className="flex-shrink-0 flex items-center justify-center" style={{
            width: '200px',
            height: '100px'
          }} data-id="element-134">
                <img src={logo.url} alt={logo.alt} className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300" loading="lazy" data-id="element-135" />
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}